export const HISTORY_LOG_ACTIVITY_CONSTANT = {
  GET_LIST_REQUESTED: 'LI/HISTORY/LOG_ACTIVITY/get-list/requested',
  GET_LIST_SUCCESS: 'LI/HISTORY/LOG_ACTIVITY/get-list/success',
  GET_LIST_FAILED: 'LI/HISTORY/LOG_ACTIVITY/get-list/failed',

  RESET_STATUS: 'LI/HISTORY/LOG_ACTIVITY/reset-status',
  RESET_ALL: 'LI/HISTORY/LOG_ACTIVITY/reset-all',
};
